import { TablePagination, TablePaginationProps } from '@mui/material';

type SconTablePaginationProps = Omit<TablePaginationProps, 'labelRowsPerPage' | 'labelDisplayedRows'>;

/**
 * Tabela paginada com labels em português.
 *
 * Uso típico (com hook usePagination):
 *
 *   const pagination = usePagination();
 *
 *   const { data, isFetching } = useQuery({
 *     queryKey: ['resource', business.id, pagination.page, pagination.rowsPerPage],
 *     queryFn: () => service.getList(business.id, pagination.page + 1, pagination.rowsPerPage),
 *   });
 *
 *   // `data` deve ser IPagedResult<T> com { items, totalCount, page, pageSize, totalPages, summary? }
 *   const items = data?.items;
 *   const totalCount = data?.totalCount ?? 0;
 *
 *   // No JSX, após a lista:
 *   <SconTablePagination count={totalCount} {...pagination.tablePaginationProps} />
 *
 * O hook retorna:
 *   - page (0-based), rowsPerPage
 *   - tablePaginationProps pronto pra spread (page, rowsPerPage, onPageChange, onRowsPerPageChange)
 *   - resetPage() pra zerar ao mudar filtros/busca
 */
export const SconTablePagination: React.FC<SconTablePaginationProps> = (props) => (
  <TablePagination
    component='div'
    labelRowsPerPage='Linhas por página'
    labelDisplayedRows={({ from, to, count }) => `${from}–${to} de ${count}`}
    {...props}
  />
);
